import React from 'react';
import './DownloadConfirmationLink.scss';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { fetchConfirmationPDF } from 'Store/Order/thunks';
import Link from 'Components/Shared/Link/Link';

interface IProps {
  orderID: number;
}

interface IPropsInternal {
  fetchConfirmationPDF: (orderID: number) => void;
}

type Props = IProps & IPropsInternal;

class DownloadConfirmationLink extends React.PureComponent<Props> {

  onClick = () => {
    this.props.fetchConfirmationPDF(this.props.orderID);
  }

  render() {
    return (
      <Link 
        style='download-confirmation-link'
        displayName='Bokningsbekräftelse'
        formattedName='order.download.confirmation'
        onClick={ this.onClick }
      />
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchConfirmationPDF,
  }, dispatch);
};

export default compose<{}, {}>(
  injectIntl,
  connect(null, mapDispatchToProps),
)(DownloadConfirmationLink);


// WEBPACK FOOTER //
// ./src/components/DownloadConfirmationLink/DownloadConfirmationLink.tsx